// extracted by mini-css-extract-plugin
export default {"content":"content_content__wEepT","title":"content_title__tOOuS","message":"content_message__WKTzg"};